Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.Utils = {

    fieldsTypeAnyList: ['PICKLIST_MULTISELECT', 'PICKLIST', 'LOOKUP', 'PICKLIST_MULTISELECT_FILTER', 'POWER_LOOKUP_LIST_FILTER'],

    getSectionTitle: function (message) {
        var div = document.createElement('div');
        var h1 = document.createElement('h1');
        div.className = 'MonetUIFormSectionTitle';
        h1.innerHTML = Monet.I18n.getResourcesByKey(message);

        div.appendChild(h1);
        return div;
    },

    getSectionTitleWithBtnNew: function (titleResourceId, btnCallback) {

        var titleContainer = document.createElement('div');
        var title = document.createElement('div');
        var btnNew = document.createElement('div');

        titleContainer.className = 'titleContainer';
        title.className = 'title';

        btnNew.className = 'button new';
        btnNew.title     = Monet.I18n.getResourcesByKey('PanelBuilder.tooltip.add') + ' ' + Monet.I18n.getResourcesByKey(titleResourceId);
        title.innerHTML  = Monet.I18n.getResourcesByKey(titleResourceId);

        btnNew.addEventListener('click', btnCallback);

        titleContainer.appendChild(title);
        titleContainer.appendChild(btnNew);
        return titleContainer;
    },

    getBtnDelete: function (callbackDelete) {
        var deleteBtn = document.createElement('div');
        deleteBtn.className = 'button remove';
        deleteBtn.addEventListener("click", callbackDelete);

        return deleteBtn;
    },

    checkPermissions: function (type) {
        const { permissions } = Monet.Session.Security; 
        if ( permissions ) {
            const hasPermission = permissions.find(
              (el) => {
                  if (el.key === type) {
                    return true;
                  }
              } 
            );
            return !!hasPermission;
        }
        return false;
    },

    getBtnDragDropHandler: function () {
        var handler = document.createElement('div');

        handler.className = 'dragAndDrop';

        return handler;
    },

    getBtnNewItem: function (labelResource, callback) {
        var container = document.createElement('div');
        var label = document.createElement('div');
        var newAttributeBtn = document.createElement('div');

        label.innerHTML = Monet.I18n.getResourcesByKey(labelResource);
        container.addEventListener('click', callback);

        container.className = 'newItemContainer';
        label.className = 'btnNewItemLabel';
        newAttributeBtn.className = 'newAttributeBtn';

        container.appendChild(newAttributeBtn);
        container.appendChild(label);
        return container;
    },

    getFirstField: function (fieldList) {
        var keys = Object.keys(fieldList);
        return fieldList[keys[0]];
    },

    getAttributeName: function (field) {

        var attribute = field.name,
            type      = field.type,
            hasMany   = (field.meta ? field.meta.hasMany : null);

        if (hasMany) {
            if (type === 'TEXT') {
                attribute = hasMany.collectionName + '.' + hasMany.entityName + '.' + (field.lookupEntityColumn || hasMany.lookupEntityColumn);
            } else {
                attribute = hasMany.criteriaChainAttribute;
            }
        } else if (this.fieldsTypeAnyList.indexOf(type) !== -1 && field.lookupEntity) {
            attribute += '.id';
        } else if (field.lookupEntityColumn) {
            attribute += '.' + field.lookupEntityColumn;
        }

        return attribute;
    },

    getValueToUserFormat: function (field, value) {

        if (field && this.fieldsTypeAnyList.indexOf(field.type) !== -1 && field.lookupEntity) {
            value = JSON.parse(value);
        }

        return value;
    },

    getValueToServer: function (field, value) {

        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }

        return value;
    }

};
